import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../../config/firebase';

function parseAdminUidSet() {
  const raw = import.meta.env.VITE_FEEDBACK_ADMIN_UIDS || '';
  const uids = raw
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
  return new Set(uids);
}

export default function AdminRoute({ children }) {
  const { currentUser, loading } = useAuth();
  const location = useLocation();
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [checked, setChecked] = React.useState(false);
  if (loading) return null;
  if (!currentUser) return <Navigate to={`/login${location.search}`} replace />;

  React.useEffect(() => {
    let mounted = true;
    const local = parseAdminUidSet();
    if (local.size > 0) {
      if (mounted) {
        setIsAdmin(local.has(currentUser.uid));
        setChecked(true);
      }
      return () => {
        mounted = false;
      };
    }
    (async () => {
      try {
        const snap = await getDoc(doc(firestore, 'appConfig', 'feedback'));
        const uids = snap.exists() ? (snap.data()?.adminUids || []) : [];
        const ok = Array.isArray(uids) && uids.includes(currentUser.uid);
        if (mounted) setIsAdmin(ok);
      } catch (e) {
        console.error('AdminRoute config read error:', e);
        if (mounted) setIsAdmin(false);
      } finally {
        if (mounted) setChecked(true);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [currentUser.uid]);

  if (!checked) return null;
  return isAdmin ? children : <Navigate to="/" replace />;
}

